import ActivityModel from '@/Modules/Activity/ActivityModel.js'
import axios from 'axios'

export default class ActivityService {
  static list = ({ parameters, filters }) =>
    axios.get(`activities${ filters }`, { params: parameters, excludeLoader: true })

  static create = (payload) =>
    axios.post(`activities`, payload)

  static update = (activityId, payload) =>
    axios.put(`activities/${ activityId }`, payload)

  static updateReminder = (activityId, payload) =>
    axios.put(`activities/${ activityId }/update-reminder`, payload)

  static updateStatus = (activityId, payload) =>
    axios
      .put(`activities/${ activityId }/update-status`, payload)
      .then(response => new ActivityModel(response.data.data))

  static delete = activityId =>
    axios.delete(`activities/${ activityId }`)

  static show = id => axios
    .get(`activities/${ id }`)
    .then(response => new ActivityModel(response.data.data))
}
